import styled from 'styled-components';
import { Button } from 'antd';

export const ExpandChildrenButton = styled(Button)`  
 &.ant-btn.ant-btn-icon-only {
    width: auto;
    padding-right: 8px;
  }
`;
